<!-- filepath: c:\Users\adilr\Desktop\Megahissotto-F\MegaHissotto-F-master\src\pages\Home.vue -->
<template>
  <div v-if="loading" class="loading-spinner">
    <div class="loader">
      <div class="box box-1">
        <div class="side-left"></div>
        <div class="side-right"></div>
        <div class="side-top"></div>
      </div>
      <div class="box box-2">
        <div class="side-left"></div>
        <div class="side-right"></div>
        <div class="side-top"></div>
      </div>
      <div class="box box-3">
        <div class="side-left"></div>
        <div class="side-right"></div>
        <div class="side-top"></div>
      </div>
      <div class="box box-4">
        <div class="side-left"></div>
        <div class="side-right"></div>
        <div class="side-top"></div>
      </div>
    </div>
  </div>
  <div v-else class="page-content animate-slide-in">
    <Hero id="hero" />
    <About id="about" />
    <!-- <ShopByCategory id="categories" /> -->
  

    <!-- Add this fixed contact button -->
    <div class="fixed-contact">
    <button @click="toggleNumbers" class="contact-button" :class="{ 'active': showNumbers }">
      <i class="fas fa-phone"></i>
      <span>Contact</span>
    </button>
    <transition name="fade">
      <div v-if="showNumbers" class="contact-numbers">
        <div class="contact-header">
          <h4>Nos Numéros</h4>
          <button @click="toggleNumbers" class="close-btn">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div v-for="(number, index) in commercialNumbers" :key="index" class="number-item">
          <i class="fas fa-phone-alt"></i>
          <a :href="'tel:' + number.replace(/\s/g, '')">{{ number }}</a>
        </div>
      </div>
    </transition>
  </div>
    
    <!-- /**today  -->
   
    <Partenaire id="partners" />
    <Services id="services" />
    <!-- <Certificat /> -->
    <Employee id="Employee"/>
    <!-- / -->



    <!-- <DefCompany /> -->
    <!-- <Project /> -->

    <SubscribeModalApp v-if="showModal" @close="showModal = false" /> 
    <Feedback id="Feedback" />
    <Contact id="Contact" />

    <!-- <Test /> -->
    <!-- <Footer /> -->
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useHead } from '@vueuse/head'

import Hero from '@/components/Hero.vue'
import Employee from '@/components/Employee.vue'
// import Test from '@/components/Test.vue'

import About from '@/components/About.vue'
import ShopByCategory from '@/components/ShopByCategory.vue'
import Partenaire from '@/components/Partenaire.vue'
import Services from '@/components/Services.vue'
import Product from '@/components/Product.vue'
import Certificat from '@/components/Certificat.vue'
import DefCompany from '@/components/DefCompany.vue'
import SubscribeModalApp from '@/components/SubscribeModalApp.vue'
import Feedback from '@/components/Feedback.vue'
import Contact from '@/components/Contact.vue'
import Footer from '@/components/Footer.vue'
import Project from '@/pages/Project.vue'

// ===== SEO =====
useHead({
  title: 'Mega Hissotto | Climatisation, Froid Industriel & Pompes à Chaleur – Algérie',
  meta: [
    { name: 'description', content: 'Mega Hissotto – Leader en climatisation industrielle, compresseurs INGOTECH, Panasonic, pompes à chaleur VESTADULCE / HYPNODULCE, refroidisseurs RLMTAS, évaporateurs EVPM et free-cooling télécom en Algérie.' },
    { name: 'keywords', content: 'Mega Hissotto, climatisation Algérie, compresseur INGOTECH, Panasonic, pompe à chaleur, froid industriel, RLMTAS, EVPM, VESTADULCE, HYPNODULCE, Rooftop, armoire précision, free cooling, HVAC Algérie' },
    { property: 'og:title', content: 'Mega Hissotto | Climatisation & Froid Industriel – Algérie' },
    { property: 'og:description', content: 'Spécialiste en climatisation industrielle, compresseurs, pompes à chaleur et systèmes de froid en Algérie.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://www.mega-hissotto.com/' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ],
  link: [{ rel: 'canonical', href: 'https://www.mega-hissotto.com/' }]
})

const showModal = ref(false);
const loading = ref(true);

// 
const showNumbers = ref(false);
const commercialNumbers = ref([
  '+212 522 123 456',
  '+212 522 987 654',
  '+212 522 567 890'
]);
const toggleNumbers = () => {
  showNumbers.value = !showNumbers.value;
};
// 


onMounted(() => {
  setTimeout(() => {
    showModal.value = true;
    loading.value = false;
  }, 8000);
});


useHead({
  title: 'Megahissotto Maroc - Climatiseurs & Solutions HVAC',
  meta: [
    {
      name: 'description',
      content: 'Bienvenue chez Megahissotto - Experts en climatisation, froid industriel et solutions HVAC pour télécommunications au Maroc.'
    },
    {
      name: 'keywords',
      content: 'HVAC Maroc, Megahissotto, climatisation Maroc, froid industriel, télécommunication, air control, air power, installation, maintenance'
    },
    {
      property: 'og:title',
      content: 'Megahissotto - Air Power, Air Control, Air Autonomy'
    },
    {
      property: 'og:description',
      content: 'Climatiseurs pour enceintes de télécommunication, solutions HVAC fiables et performantes. Megahissotto respecte ses engagements.'
    },
    {
      property: 'og:url',
      content: 'http://www.mega-hissotto.com'
    },
    {
      property: 'og:type',
      content: 'website'
    }
  ],
  link: [
    {
      rel: 'canonical',
      href: 'http://www.mega-hissotto.com'
    }
  ]
})

</script>

<style scoped>
.fixed-contact {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.contact-button {
  background-color: #286cb5;
  color: white;
  border: none;
  border-radius: 50px;
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 12px rgba(40, 108, 181, 0.3);
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
}

.contact-button:hover {
  background-color: #2f85e0;
  transform: translateY(-3px);
  box-shadow: 0 8px 15px rgba(40, 108, 181, 0.4);
}

.contact-button.active {
  background-color: #1a5798;
}

.contact-button i {
  font-size: 18px;
}

.contact-numbers {
  background-color: white;
  border-radius: 12px;
  padding: 0;
  margin-top: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  width: 250px;
  overflow: hidden;
  border: 1px solid #eaeaea;
}

.contact-header {
  background-color: #286cb5;
  color: white;
  padding: 12px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contact-header h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.number-item {
  padding: 14px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: background-color 0.2s;
}

.number-item:last-child {
  border-bottom: none;
}

.number-item:hover {
  background-color: #f8f9fa;
}

.number-item i {
  color: #286cb5;
  font-size: 14px;
}

.number-item a {
  color: #333;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s;
  font-size: 15px;
}

.number-item a:hover {
  color: #2f85e0;
}

/* Animation */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}













/* fn */
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff; /* blue-400 */
}

/* 3D tower loader made by: csozi | Website: www.csozi.hu */
.loader {
  scale: 3;
  height: 50px;
  width: 40px;
}

.box {
  position: relative;
  opacity: 0;
  left: 10px;
}

.side-left {
  position: absolute;
  background-color: #286cb5;
  width: 19px;
  height: 5px;
  transform: skew(0deg, -25deg);
  top: 14px;
  left: 10px;
}

.side-right {
  position: absolute;
  background-color: #2f85e0;
  width: 19px;
  height: 5px;
  transform: skew(0deg, 25deg);
  top: 14px;
  left: -9px;
}

.side-top {
  position: absolute;
  background-color: #5fa8f5;
  width: 20px;
  height: 20px;
  rotate: 45deg;
  transform: skew(-20deg, -20deg);
}

.box-1 {
  animation: from-left 4s infinite;
}

.box-2 {
  animation: from-right 4s infinite;
  animation-delay: 1s;
}

.box-3 {
  animation: from-left 4s infinite;
  animation-delay: 2s;
}

.box-4 {
  animation: from-right 4s infinite;
  animation-delay: 3s;
}

@keyframes from-left {
  0% {
    z-index: 20;
    opacity: 0;
    translate: -20px -6px;
  }

  20% {
    z-index: 10;
    opacity: 1;
    translate: 0px 0px;
  }

  40% {
    z-index: 9;
    translate: 0px 4px;
  }

  60% {
    z-index: 8;
    translate: 0px 8px;
  }

  80% {
    z-index: 7;
    opacity: 1;
    translate: 0px 12px;
  }

  100% {
    z-index: 5;
    translate: 0px 30px;
    opacity: 0;
  }
}

@keyframes from-right {
  0% {
    z-index: 20;
    opacity: 0;
    translate: 20px -6px;
  }

  20% {
    z-index: 10;
    opacity: 1;
    translate: 0px 0px;
  }

  40% {
    z-index: 9;
    translate: 0px 4px;
  }

  60% {
    z-index: 8;
    translate: 0px 8px;
  }

  80% {
    z-index: 7;
    opacity: 1;
    translate: 0px 12px;
  }

  100% {
    z-index: 5;
    translate: 0px 30px;
    opacity: 0;
  }
}

.page-content {
  animation: slide-in 1s ease-out;
}

@keyframes slide-in {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
